import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PasoonVoiceIntro } from '../components/PasoonVoiceIntro';
import { IntroSection } from '../components/IntroSection';
import { AboutSection } from '../components/AboutSection';
import { CurrentIssue } from '../components/CurrentIssue';
import { PublishingCycle } from '../components/PublishingCycle';
import { ArchivePreview } from '../components/ArchivePreview';
import { SubscriptionSupport } from '../components/SubscriptionSupport';
import { Language } from '../App';
interface HomeProps {
  language: Language;
}
export function Home({
  language
}: HomeProps) {
  return <div data-id="element-511">
      <HeroSection language={language} data-id="element-512" />
      <PasoonVoiceIntro language={language} data-id="element-513" />
      <IntroSection language={language} data-id="element-514" />
      <AboutSection language={language} data-id="element-515" />
      <CurrentIssue language={language} data-id="element-516" />
      <PublishingCycle language={language} data-id="element-517" />
      <ArchivePreview language={language} data-id="element-518" />
      <SubscriptionSupport language={language} data-id="element-519" />
    </div>;
}